module.exports = __webpack_public_path__ + "static/media/icono_guardados_blanco.ffcdfd4e.svg";